import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import EmailIcon from "@mui/icons-material/Email";
import FavoriteIcon from "@mui/icons-material/Favorite";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tab from "@mui/material/Tab";
import ToggleButton from "@mui/material/ToggleButton";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import AddIcon from "@mui/icons-material/Add";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { useLocation, useSearchParams } from "react-router-dom";
import ClientAddress from "./ClientAddress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../../components/CustomLoader";
import Fade from "@mui/material/Fade";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Ad_SetClientIdReducer,
  EditCompanyOpenMdalReducer,
} from "../../redux/adityaReducer";
import {
  getClientIdMethod_Redux,
  getFolderObject_Redux,
} from "../../redux/akSlice";
import { devApi } from "../../redux/AxiosInstance";
import { ad_DeleteClient_Json_DeleteSuppliers_Action } from "../../redux/dev_aditya_action";
import ClientOverview from "./ClientOverview";
import ClientsContacts from "./ClientsContacts";
import CompanyDetails from "./CompanyDetails";
import UdfCard from "./UdfCard";
import { handleOpenContactModal } from "../../redux/docuSlice";
import ClientNotes from "./ClientNotes";

const agrno = localStorage.getItem("agrno");
const Email = localStorage.getItem("Email");
const password = localStorage.getItem("password");
const folderId = localStorage.getItem("FolderId");

function ClientDetails() {
  const location = useLocation();
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabValue = searchParams.get("val");
  // const test = searchParams.get("OrgNo");
  const paramFOlderId = searchParams.get("folder");

  const originatorNo = searchParams.get("OrgNo");

  const { globalSearchDocs } =
    location?.state !== null ? location?.state : { globalSearchDocs: [] };

  const [selected, setSelected] = React.useState(false);
  const [value, setValue] = React.useState(tabValue ? tabValue : "1");
  const [clientDetails, setClientDetails] = useState({});
  const [allContactList, setAllContactList] = useState([]);

  const [companyDetails, setCompanyDetails] = useState([]);
  const [companyEditDetails, setCompanyEditDetails] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    folderId && dispatch(getFolderObject_Redux(`${folderId}`));
    originatorNo && dispatch(getClientIdMethod_Redux(`${originatorNo}`));
  }, [folderId, originatorNo]);

  // upload document modal start
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClickOpenUploadDocument = () => {
    // dispatch(setOpenDocumentModalByRedux(true));
  };
  // upload document modal end

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDelete = () => {
    dispatch(
      ad_DeleteClient_Json_DeleteSuppliers_Action(
        { CCodeList: originatorNo },
        (res) => {
          console.log(res, "=== res");
          if (res?.d) {
            toast.success(res?.d);
          }
          navigate("/user/contact/companies");
        }
      )
    );
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const Json_GetToFavourites = async () => {
    let obj = {
      agrno: agrno,
      Email: Email,
      password: password,
    };
    try {
      const res = await devApi.post("/Json_GetToFavourites", obj);
      if (res.data && res.data.d) {
        let favouriteUser = JSON.parse(res.data.d).Table;
        if (favouriteUser.length > 0) {
          let ans = favouriteUser
            .map((itm) => itm.OriginatorNo.trim())
            .includes(originatorNo.trim());
          if (ans) {
            setSelected(true);
          } else {
            setSelected(false);
          }
        } else {
          setSelected(false);
        }
      }
    } catch (err) {
      console.log("Error while calling Json_GetToFavourites", err);
    }
  };

  const Json_RemoveToFavourite = async () => {
    let obj = {
      agrno: agrno,
      Email: Email,
      password: password,
      OrgNo: originatorNo,
      ProjectID: folderId,
    };
    await devApi.post("/Json_RemoveToFavourite", obj);
    // toast.success("Removed from favourites");
    setSelected(false);
  };

  const Json_AddToFavourite = async () => {
    let obj = {
      agrno: agrno,
      Email: Email,
      password: password,
      ProjectID: folderId,
      OrgNo: originatorNo,
    };
    await devApi.post("/Json_AddToFavourite", obj);
    // toast.success("Added to favourites");
    // dispatch(fetchSupplierListOrderByFavourite());
    setSelected(true);
  };

  const Json_GetClientCardDetails = async () => {
    let obj = {
      Email: Email,
      agrno: agrno,
      intProjectId: folderId,
      password: password,
      strOrignatorNumber: originatorNo,
    };
    try {
      const res = await devApi.post("/Json_GetClientCardDetails", obj);
      if (res.data && res.data.d) {
        let json = JSON.parse(res.data.d);
        setClientDetails(json);
        setCompanyDetails(json.Table1);
        setCompanyEditDetails(json.Table1);
        setAllContactList(json.Table6);
      }
    } catch (err) {
      console.log("Error while calling Json_GetClientCardDetails", err);
    }
  };

  useEffect(() => {
    Json_GetClientCardDetails();
    Json_GetToFavourites();
  }, []);

  // edit client modal
  const [Referance, setReferance] = React.useState(false);
  const handleClickReferance = (e, originatorNo) => {
    // setReferance(true);
    dispatch(EditCompanyOpenMdalReducer(true));
  };
  const EditCLientHandleClose = () => {
    setReferance(false);
    dispatch(EditCompanyOpenMdalReducer(true));
  };

  const [Notesopen, NotessetOpen] = React.useState(false);

  const NoteshandleClickOpen = () => {
    NotessetOpen(true);
  };
  const NoteshandleClose = () => {
    NotessetOpen(false);
  };

  const PortalMessageBtn = () => {
    dispatch(getFolderObject_Redux(`${value.FolderID}`));
    dispatch(getClientIdMethod_Redux(`${value.ClientID}`));
    navigate(
      `/user/portal-messages?argno=${originatorNo}&folderId=${paramFOlderId}`
    );
  };

  return (
    <>
      <Box className="container-fluid p-0 mt-2">
        {/* <CustomBreadCrumbs tabs={[{ tabLink: "/dashboard/Connections", tabName: "Connections" }, { tabLink: "/dashboard/clientDetails", tabName: "Client Details" }]} /> */}

        {globalSearchDocs.length === 0 && (
          <Box className="d-flex align-items-center justify-content-between flex-wrap">
            <Box className="d-flex flex-wrap align-items-center">
              <Typography variant="h5" className="title semibold me-3 mb-2">
                {clientDetails.Table1 &&
                  clientDetails?.Table1[0]?.OriginatorName}
              </Typography>

              <ToggleButton
                value="check"
                selected={selected}
                onChange={() => {
                  //setSelected(!selected);
                  if (selected) {
                    Json_RemoveToFavourite();
                  } else {
                    Json_AddToFavourite();
                  }
                }}
                className="mb-2 p-1 btn-favorite"
              >
                <FavoriteIcon />
              </ToggleButton>
            </Box>

            <Box className="d-flex align-items-center  gap-1 flex-wrap">
              <Button
                className="btn-blue "
                size="small"
                startIcon={<MarkunreadIcon />}
                onClick={PortalMessageBtn}
              >
                Portal Messages
              </Button>

              <Button
                className="btn-blue "
                size="small"
                startIcon={<BorderColorIcon />}
                onClick={(e) => handleClickReferance(e, originatorNo)}
              >
                Edit Client
              </Button>
              {/* <Button className='btn-blue-2 me-2 mb-1' size="small" startIcon={<GroupAddIcon />}>Add Client</Button> */}
              <Button
                className="btn-blue "
                size="small"
                startIcon={<NoteAltIcon />}
                onClick={NoteshandleClickOpen}
              >
                Notes
              </Button>
              <Button
                className="btn-blue"
                size="small"
                startIcon={<AddIcon />}
                onClick={handleClickOpenUploadDocument}
              >
                Add Document
              </Button>

              <Button
                className="btn-blue"
                size="small"
                startIcon={<PersonAddIcon />}
                onClick={() => {
                  dispatch(handleOpenContactModal(true));
                  dispatch(Ad_SetClientIdReducer(originatorNo));
                }}
              >
                Add Contact
              </Button>

              <div>
                <Button
                  id="fade-button"
                  aria-controls={open ? "fade-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  className="min-width-auto mb-1"
                  startIcon={<MoreVertIcon />}
                ></Button>
                <Menu
                  id="fade-menu"
                  MenuListProps={{
                    "aria-labelledby": "fade-button",
                  }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  TransitionComponent={Fade}
                  className="custom-dropdown"
                >
                  <MenuItem className="ps-1" onClick={handleDelete}>
                    <ListItemIcon>
                      <DeleteIcon fontSize="small" />
                    </ListItemIcon>
                    Delete Client
                  </MenuItem>
                </Menu>
              </div>
            </Box>
          </Box>
        )}
        {/* <hr /> */}
        <Box sx={{ width: "100%", typography: "body1" }} className="">
          <TabContext value={value}>
            <Box className="mb-1">
              <TabList
                onChange={handleChange}
                aria-label="lab API tabs example"
                className="custom-tabs"
              >
                <Tab label="General" value="1" />
                <Tab label="Address" value="2" />
                <Tab label="Contact" value="3" />
                {/* <Tab label="Tasks" value="4" />
                <Tab label="Documents" value="5" />
                <Tab label="Companies House" value="6" />
                <Tab label="Requested Document" value="7" /> */}
              </TabList>
            </Box>
            <TabPanel value="1" className="p-0">
              {clientDetails && clientDetails?.Table3?.length > 0 ? (
                <>
                  <Box className="general-tab white-box">
                    <Box className="row mb-2">
                      {/* For CompanyDetails */}
                      <CompanyDetails
                        companyDetails={companyDetails}
                        originatorNo={originatorNo}
                      />
                      {/* <CompanyDetails companyDetails={companyDetails} originatorNo={originatorNo} Cls={Cls} /> */}
                      {/* For ClientOverview */}
                      <ClientOverview originatorNo={originatorNo} />
                      {/* <ClientOverview Cls={Cls} webClientCLS={webClientCLS} locationState={{ agrno: agrno, Email: Email, password: password, folderId: folderId, originatorNo: originatorNo }} /> */}
                    </Box>
                    <hr className="mt-0" />
                  </Box>
                  <Box className="main-accordian">
                    <UdfCard data={clientDetails} />
                    {/* For UDFs */}
                  </Box>
                </>
              ) : (
                <CustomLoader />
              )}
            </TabPanel>

            <TabPanel value="2" className="p-0">
              <ClientAddress originatorNo={originatorNo}></ClientAddress>
            </TabPanel>
            <TabPanel value="3" className="p-0 relative">
              <ClientsContacts allContactList={allContactList} />
              {/* <Contact clientId={clientDetails.Table1 && clientDetails?.Table1[0]?.OriginatorNo} clientName={clientDetails.Table1 && clientDetails?.Table1[0]?.OriginatorName}></Contact> */}
            </TabPanel>
            {/* <TabPanel value="4" className="p-0 relative">
              Taskist here
              <TaskList clientName={clientDetails.Table1 && clientDetails?.Table1[0]?.OriginatorNo}></TaskList>
            </TabPanel> */}

            {/* <TabPanel value="5" className="p-0 relative">
              DocumentList here
              <DocumentList clientId={originatorNo} globalSearchDocs={globalSearchDocs} ></DocumentList>
            </TabPanel> */}

            {/* <TabPanel value="5">
                        <DocumentList/>
                    </TabPanel> */}
            {/* <TabPanel value="6" className="p-0">
              CompaniesHouse here
              <CompaniesHouse></CompaniesHouse>
            </TabPanel>
            <TabPanel value="7">
              <RequestedDocs Email={companyDetails[0]?.Email} />
            </TabPanel> */}
          </TabContext>
        </Box>
      </Box>

      {/* edit Referance modal */}
      <Dialog
        open={Referance}
        onClose={EditCLientHandleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="custom-modal full-modal"
      >
        <Box className="d-flex align-items-center justify-content-between modal-head">
          <Box className="dropdown-box">
            <Typography variant="h4" className="font-18 bold text-black">
              Edit Client
            </Typography>
          </Box>

          {/*  */}
          <Button onClick={EditCLientHandleClose}>
            <span className="material-symbols-outlined text-black">cancel</span>
          </Button>
        </Box>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            EditReference here
            {/* <EditReference companyEditDetails={companyEditDetails}></EditReference> */}
          </DialogContentText>
        </DialogContent>
        {/* <DialogActions>
                    <Button onClick={EditCLientHandleClose}>Disagree</Button>
                    <Button onClick={EditCLientHandleClose} autoFocus>
                        Agree
                    </Button>
                </DialogActions> */}
      </Dialog>

      {Notesopen && (
        <ClientNotes
          Notesopen={Notesopen}
          NoteshandleClose={NoteshandleClose}
        />
      )}
    </>
  );
}

export default ClientDetails;
